module.exports = __webpack_public_path__ + "img/closebtn.f2ca0edb.svg";